// Shared status constants for Telecom and Energy business areas

export const TELECOM_STATUSES = [
  'Atendeu', 'Não Atribuido', 'Não Atendeu',
  'Fecho', 'Pendente', 'Follow-up', 'Sem Interesse', 'Fidelizado', 'Informação Errada', 'Sem Cobertura',
  'Placeholder1', 'Placeholder2', 'Fechado'
];

export const TELECOM_SECTIONS = {
  entrada: ['Não Atribuido', 'Não Atendeu'],
  feedback: ['Atendeu', 'Pendente', 'Follow-up', 'Sem Interesse', 'Fidelizado', 'Informação Errada', 'Sem Cobertura'],
  registro: ['Fecho', 'Validação']
};

export const ENERGY_STATUSES = [
  'Entrada', 'Pendente', 'Validação', 'Fecho', 'Perdido', 'Fechado'
];

export const ENERGY_SECTIONS = {
  entrada: ['Entrada'],
  feedback: ['Pendente', 'Validação', 'Fecho'],
  registro: ['Perdido', 'Fechado']
}; 